import React from 'react';
import { View, GridColumn, Heading, Text, Button } from '@fairygodboss/ui';
import window from 'global/window';
import { AuthWrapper } from '../../../../../../pages/HomePage_v2/sections/components/AuthWrapper';
import { EmitMetric } from '../../../../../Analytics/VisibilityPixel/VisibilityPixel';
import { DividerSVG } from '../../ContentBody/ConvincerSVGs';

export const CommentConvincer = ({ type }) => {
    const metric =
        type === 'community-podcast' || type === 'editorial-content'
            ? 'article_comment_signup'
            : 'single';
    const loginTrigger =
        type === 'community-podcast' || type === 'editorial-content'
            ? 'article_comment_signup'
            : 'community-discussion-register';
    return (
        <View display={{ _: 'none', md: 'inherit' }}>
            <GridColumn
                size={{
                    xs: 0,
                    sm: 0,
                    md: window.innerWidth > 1054 ? 3 : 4,
                    lg: 3.05,
                }}
                pr={{ _: '0px', md: '24px', lg: '0px' }}
                pt="78px"
                css={{
                    paddingLeft: '6px',
                    position: 'absolute',
                    right: '0px',
                    button: {
                        span: {
                            letterSpacing: '-0.4px',
                            marginLeft: '-3px',
                        },
                    },
                }}
            >
                <DividerSVG width="100" />
                <Heading
                    fontWeight="700"
                    variant="headingXs"
                    pt="6px"
                    pb="10px"
                    as="h3"
                >
                    Share your insight
                </Heading>
                <Text mb="6px">
                    Join an authentic community that helps women support each
                    other at work. Share your professional experience or ask for
                    advice — you can even post anonymously.
                </Text>
                <AuthWrapper
                    component={
                        <Button
                            onPress={() => {
                                EmitMetric({
                                    misc_event_type: metric,
                                    misc_event_count: 1,
                                });
                            }}
                            px="28px"
                            py="14px"
                            height="48px"
                            fontWeight="600"
                            fontSize="16px"
                            lineHeight="20px"
                            mt="8px"
                            width="146px"
                        >
                            Sign up now
                        </Button>
                    }
                    redirectUrl="/community/feed"
                    loginTrigger={loginTrigger}
                />
            </GridColumn>
        </View>
    );
};
